import * as React from "react";
import { SVGProps } from "react";

const UsersSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18 6A6 6 0 1 1 6 6a6 6 0 0 1 12 0ZM4.5 19A4.5 4.5 0 0 1 9 14.5h6a4.5 4.5 0 0 1 4.5 4.5v2a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 21v-2ZM3 19a6 6 0 0 1 6-6h6a6 6 0 0 1 6 6v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2Z"
    />
  </svg>
);

export default UsersSVG;
